import {clientRequest} from '../apiClient';

type RegisterFields = {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  language?: string;
};

const register = (registerFields: RegisterFields) => {
  return clientRequest<any>({url: '/users', body: registerFields, options: {method: 'POST'}});
};

export default register;
